import _ from "lodash";
import moment from "moment";
import DashboardMode from "../constants/DashboardMode";
import { UserRoles } from "../constants/UserRoles";
import { DATE_TYPE_OPTIONS } from "../constants/DateConstants";

const FILTER_TYPE = ["status", "jobType", "idType", "delivery"];
const headers = [
  {
    name: "fromDate",
    label: "From Date",
    type: "date",
  },
  {
    name: "toDate",
    label: "To Date",
    type: "date",
  },
  {
    name: "dateField",
    label: "Date Type",
    type: "text",
  },
  {
    name: "textSearch",
    label: "Search",
    type: "text",
  },
  {
    name: "nmo",
    label: "DMO",
    type: "text",
  },
  {
    name: "encoding",
    label: "Encoding",
    type: "text",
  },
  {
    name: "pacs",
    label: "PACS",
    type: "text",
  },
  {
    name: "myDrafts",
    label: "My Drafts",
    type: "text",
  },
  {
    name: "myFavorite",
    label: "My Favorites",
    type: "text",
  },
  {
    name: "myTeamData",
    label: "My Team's Jobs",
    requestLabel: "My Team's Requests",
    type: "boolean",
  }
];

export default class FilterUtils {
  static getMapValue(query, filterParams, role, dashboardView) { 
    const filteroutFields = FilterUtils.renderUserFilters(role, filterParams, query);
    let mapValue = [];
    _.map(filteroutFields, (filter) => {
      mapValue.push({
        label: filter.label,
        key: filter.name,
        value: FilterUtils.renderValue(filter.values, _.get(query, filter.name)),
      });
    });

    _.map(headers, (val) => {
      if (!_.isEmpty(_.get(query, val.name, ""))) {
        mapValue.push({
          label: val.label,
          key: val.name,
          value: FilterUtils.handleHeaderValue(val, query, dashboardView),
          type: val.type,
        });
      } else if (val.name === "myTeamData" && _.get(query, val.name, "")) {
        mapValue.push({
          label: dashboardView === DashboardMode.JOBS ? val.label : val.requestLabel,
          key: val.name,
          value: _.get(query, val.name, ""),
          type: val.type,
        });
      }
    });
    
    return mapValue;
  }
  static format(value) {
    return moment(value).format("MM/DD/YY");
  }
  static filterOut(filters, view, role) {
    let filteredResult = [];
    _.map(_.cloneDeep(filters), (filter) => {
      if (_.includes(FILTER_TYPE, filter.name)) {
        if (role !== UserRoles.GLOBALADMIN) {
          if (role === UserRoles.SUPERADMIN || role === UserRoles.REQUESTOR || role === UserRoles.OPS) {
            filter.values = _.reject(filter.values, (item) => {
              return _.get(item, "hideFromUI", false) && _.get(item, "value", "") !== "MEDIA_REQUEST";
            });
          } else {
            filter.values = _.reject(filter.values, (item) => {
              return _.get(item, "hideFromUI", false);
            });
          }
        }
        if (filter.name === "status") {
          filter.values = filter.values.sort((a, b) => a.label > b.label ? 1 : -1);
        }
      }
      if (filter.name !== "assignedTo" && filter.name !== "delivery" && view === "requests") {
        filteredResult.push(filter);
      }
      if (view !== "requests") {
        filteredResult.push(filter);
      }
    });
    return filteredResult;
  }
  static filterView(view, filters, role ) {
    return FilterUtils.filterOut(filters, view, role);
  }
  static getDateFieldLabel(value, dashboardView) {
    const options = DATE_TYPE_OPTIONS[dashboardView] || [];
    const match = _.find(options, { field: value });
    return match ? match.label : value;
  }
  static handleHeaderValue(val, query, dashboardView) {
    const rawValue = _.get(query, val.name, "");

    if (val.type === "date") {
      return FilterUtils.format(rawValue);
    }

    if (val.name === "dateField") {
      return FilterUtils.getDateFieldLabel(rawValue, dashboardView);
    }
    return rawValue;
  }

  static renderValue(values, selectedValue) {
    let dataValue = _.isEmpty(selectedValue) ? [] : _.split(selectedValue, /,/g);
    let data = [];
    _.map(dataValue, (val) => {
      const pickValue = _.find(values, (findVal) => {
        return findVal.value === val;
      });
      if (!_.isEmpty(pickValue)) {
        data.push({
          label: _.get(pickValue, "label", ""),
          value: _.get(pickValue, "value"),
        });
      }
    });
    return data;
  }

  static renderUserFilters = (role, filterParams, query) => {
    let filters = [];
    _.map(filterParams, (filter) => {
      if (_.indexOf(filter.permissions, role) !== -1 && _.has(query, filter.name)) {
        filters.push(filter);
      }
    });
    return filters;
  };
}
